import { useTranslation } from 'react-i18next';
import { Button } from '@hostfully/ui-components';
import { HF_ACCOUNTING_CONTACT_URL } from '../HostfullyAccounting.constants';

interface ContactUsButtonProps {
  testId: string;
}

const openContactUs = () =>
  window.open(HF_ACCOUNTING_CONTACT_URL, '_blank', 'noopener,noreferrer');

const ContactUsButton = ({ testId }: ContactUsButtonProps) => {
  const { t } = useTranslation();

  return (
    <Button
      variant="primary"
      type="button"
      onClick={openContactUs}
      data-testid={testId}
    >
      {t('pageHostfullyAccounting.marketing.ctaLabel')}
    </Button>
  );
};

export default ContactUsButton;
